import { render } from "./AddShipping.vue?vue&type=template&id=953c4d06&scoped=true"
import script from "./AddShipping.vue?vue&type=script&lang=js"
export * from "./AddShipping.vue?vue&type=script&lang=js"

import "./AddShipping.vue?vue&type=style&index=0&id=953c4d06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953c4d06"]])

export default __exports__